import { createFileRoute } from "@tanstack/react-router";
import { WarehouseClearancePage } from "@/features/reports/warehouse-clearance-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/wyprzedaz-magazynu")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.wyprzedaz-magazynu",
			location.pathname,
		);
	},
	component: WarehouseClearancePage,
});
